import styled, { css } from "styled-components";
import { ACCORDION_TRANSITION_TIMING } from "./utils";
export var CustomizedCollapsableComponent = styled.div.withConfig({
    componentId: "sc-73997d9c-0"
})([
    "position:relative;text-align:start;word-break:break-word;white-space:pre-wrap;width:100%;overflow:hidden;",
    " transition-property:max-height;",
    " ",
    ""
], function(param) {
    var $isAccordionOpen = param.$isAccordionOpen, $componentExpandedHeight = param.$componentExpandedHeight, $componentCollapsedHeight = param.$componentCollapsedHeight;
    return $isAccordionOpen ? css([
        "max-height:",
        "px;"
    ], $componentExpandedHeight) : css([
        "max-height:",
        "px;"
    ], $componentCollapsedHeight);
}, ACCORDION_TRANSITION_TIMING, function(param) {
    var $isList = param.$isList;
    return $isList ? css([
        "left:-2px;padding-left:2px;"
    ]) : "";
});
